import { useQuery, useQueryClient } from '@tanstack/react-query'
import { axiosInstance } from '../../../helpers'
import { AxiosResponse } from 'axios'
import { Organization } from '../../../models'

export const useOrganizations = () => {
    const queryClient = useQueryClient()
    const queryKey = ['admin-organization']
    const {
        data: organizationList,
        isLoading,
        isError,
        error,
        refetch,
    } = useQuery<AxiosResponse<Organization[]>, Error>({
        queryKey,
        queryFn: () => axiosInstance.get('/account-manager/organizations/'),
    })

    return {
        organizationList,
        isLoading,
        isError,
        error,
        refetch,
    }
}
